//codex-- Let office users select either separate feed, defaulting to Office Wall on every page mount.
import React, { useState } from 'react';
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import PostComment from './PostComment';
import TechWall from '../mobile/TechWall';

//codex-- Keep visited feeds mounted to preserve drafts; defer Tech Wall loading until its first selection.
export default function OfficeWalls() {
  const [techVisited, setTechVisited] = useState(false);
  const tabClass = ({ selected }) => `min-h-[44px] flex-1 rounded-xl border px-3 py-2 text-sm font-semibold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${selected
    ? 'border-indigo-200 bg-indigo-50 text-indigo-700'
    : 'border-transparent text-slate-600 hover:bg-slate-50'}`;

  return (
    <TabGroup defaultIndex={0} onChange={(index) => { if (index === 1) setTechVisited(true); }}>
      {/* //codex-- Accessible tabs provide clear selection and keyboard navigation without storing a wall preference. */}
      <TabList aria-label="Choose a wall" className="mb-4 flex gap-2 rounded-2xl border border-slate-200 bg-white p-2 shadow-sm">
        <Tab className={tabClass}>Office Wall</Tab>
        <Tab className={tabClass}>Tech Wall</Tab>
      </TabList>
      {/* //codex-- Hide inactive panels instead of discarding text, attachments, or reply drafts. */}
      <TabPanels>
        <TabPanel unmount={false}><PostComment /></TabPanel>
        <TabPanel unmount={false}>{techVisited && <TechWall />}</TabPanel>
      </TabPanels>
    </TabGroup>
  );
}
